import CompanyCreationSerializer from './-company-creation';

export default CompanyCreationSerializer.extend({});
